import { useRoute } from "@react-navigation/native";
import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useCallback } from "react";
import { View, XStack } from "tamagui";
import { usePlanNavigation } from "../../plans/usePlanNavigation";
import { Label } from "../Label";
import { BackButton } from "./BackButton";

export const ProfileHeader: React.FC = () => {
  const route =
    useRoute<
      NativeStackScreenProps<ReactNavigation.RootParamList, "Module">["route"]
    >();
  const navigation = usePlanNavigation();

  const goToFallback = useCallback(() => {
    navigation.replace("Plan", { planUid: route.params.planUid });
  }, [navigation, route]);

  return (
    <View backgroundColor={"$backgroundBlock"}>
      <XStack
        alignItems="stretch"
        gap="$space.small"
        width="100%"
        justifyContent="space-between"
      >
        <XStack
          flex={1}
          padding="$space.large"
          gap="$space.small"
          alignItems="center"
        >
          <BackButton goToFallback={goToFallback} />
          <Label>Profile</Label>
        </XStack>
      </XStack>
    </View>
  );
};
